module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium-06.597381f7.ttf";